import App from 'App'
import 'index.css'
import React from 'react'
import ReactDOM from 'react-dom'
import reportWebVitals from 'reportWebVitals'

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
)

reportWebVitals()